export const formActionTypes = {
    AddItem: 'AddItem',
    RemoveItem: 'RemoveItem',
    SelectItem: 'SelectItem',
    UpdateTabName: 'UpdateTabName'
}
